import { SidebarDivider } from '@equifinance/shared';
import { PostOfferRefName } from './Sections/PostOfferSection';
import { AMLFraudChecksRefName } from './Sections/AMLSection';
import { BankruptcyCheckRefName } from './Sections/BankruptcySection';
import { ElectoralRollRefName } from './Sections/ElectoralRollSection';
import { IncomeRefName } from './Sections/IncomeSection';
import { ProductRefName } from './Sections/ProductSection';
import { PolicyShieldsRefName } from './Sections/PolicyShieldsSection';
import { OSRefName } from './Sections/LandRegistrySection';
import { ReportOnTitleRefName } from './Sections/ReportOnTitleSection';
import { AdditionalSupportRefName } from './Sections/AdditionalSupportSection';
import { useChecklistContext } from '../../contexts';
import { useTabNavHeight } from '../AccountTabNav';
import { SectionSidebarItem } from '../Sidebar';
import ProductSidebarHeader from '../Products/ProductSidebar/ProductSidebarHeader';
import ProductSidebarSummary from '../Products/ProductSidebar/ProductSidebarSummary';
import { SendOfferRefName } from './Sections/SendOfferSection';
import { ValuationRefName } from './Sections/ValuationSection';
import { OS1OS3RefName } from './Sections/OS1OS3Section';

// These refName will be used on multi-places later
// Currently, just group them in one place
const SecurityCallRefName = 'security-call';

export default function ChecklistSidebar() {
  const stickyHeaderOffset = useTabNavHeight();
  const { checklist } = useChecklistContext();

  const {
    postOffer, securityCall, sendOffer,
    fraudChecks, bankruptcyChecks, electoralRoll,
    income, product, policyShields,
    landRegistry, reportOnTitle, additionalSupport, valuation, os1os3,
  } = checklist ?? {};

  return (
    <>
      <ProductSidebarHeader />

      <SidebarDivider />

      {postOffer && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={PostOfferRefName}
          isLocked={postOffer?.checklistIndicatorType === 'Locked'}
          isCompleted={postOffer?.checklistIndicatorType === 'Complete'}
        >
          Post Offer
        </SectionSidebarItem>
      )}

      {securityCall && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={SecurityCallRefName}
          isLocked={securityCall?.checklistIndicatorType === 'Locked'}
          isCompleted={securityCall?.checklistIndicatorType === 'Complete'}
        >
          Security Call
        </SectionSidebarItem>
      )}

      {sendOffer && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={SendOfferRefName}
          isLocked={sendOffer?.checklistIndicatorType === 'Locked'}
          isCompleted={sendOffer?.checklistIndicatorType === 'Complete'}
        >
          Send Offer
        </SectionSidebarItem>
      )}

      {fraudChecks && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={AMLFraudChecksRefName}
          isLocked={fraudChecks?.checklistIndicatorType === 'Locked'}
          isCompleted={fraudChecks?.checklistIndicatorType === 'Complete'}
        >
          AML - Applicant 1
        </SectionSidebarItem>
      )}

      {bankruptcyChecks && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={BankruptcyCheckRefName}
          isLocked={bankruptcyChecks?.checklistIndicatorType === 'Locked'}
          isCompleted={bankruptcyChecks?.checklistIndicatorType === 'Complete'}
        >
          Bankruptcy Check
        </SectionSidebarItem>
      )}

      {electoralRoll && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={ElectoralRollRefName}
          isLocked={electoralRoll?.checklistIndicatorType === 'Locked'}
          isCompleted={electoralRoll?.checklistIndicatorType === 'Complete'}
        >
          Electoral Roll
        </SectionSidebarItem>
      )}

      {income && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={IncomeRefName}
          isLocked={income?.checklistIndicatorType === 'Locked'}
          isCompleted={income?.checklistIndicatorType === 'Complete'}
        >
          Income
        </SectionSidebarItem>
      )}

      {product && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={ProductRefName}
          isLocked={product?.checklistIndicatorType === 'Locked'}
          isCompleted={product?.checklistIndicatorType === 'Complete'}
        >
          Product
        </SectionSidebarItem>
      )}

      {policyShields && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={PolicyShieldsRefName}
          isLocked={policyShields?.checklistIndicatorType === 'Locked'}
          isCompleted={policyShields?.checklistIndicatorType === 'Complete'}
        >
          Policy Shields
        </SectionSidebarItem>
      )}

      {landRegistry && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={OSRefName}
          isLocked={landRegistry?.checklistIndicatorType === 'Locked'}
          isCompleted={landRegistry?.checklistIndicatorType === 'Complete'}
        >
          OS1 / OS3
        </SectionSidebarItem>
      )}

      {reportOnTitle && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={ReportOnTitleRefName}
          isLocked={reportOnTitle?.checklistIndicatorType === 'Locked'}
          isCompleted={reportOnTitle?.checklistIndicatorType === 'Complete'}
        >
          Report on Title (ROT)
        </SectionSidebarItem>
      )}

      {additionalSupport && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={AdditionalSupportRefName}
          isLocked={additionalSupport?.checklistIndicatorType === 'Locked'}
          isCompleted={additionalSupport?.checklistIndicatorType === 'Complete'}
        >
          Additional Support
        </SectionSidebarItem>
      )}

      {os1os3 && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={OS1OS3RefName}
          isLocked={os1os3?.checklistIndicatorType === 'Locked'}
          isCompleted={os1os3?.checklistIndicatorType === 'Complete'}
        >
          OS1 / OS3
        </SectionSidebarItem>
      )}

      {valuation && (
        <SectionSidebarItem
          stickyHeaderOffset={stickyHeaderOffset}
          refName={ValuationRefName}
          isLocked={valuation?.checklistIndicatorType === 'Locked'}
          isCompleted={valuation?.checklistIndicatorType === 'Complete'}
        >
          Valuation
        </SectionSidebarItem>
      )}

      <ProductSidebarSummary />
    </>
  );
}
